import { render, staticRenderFns } from "./MdtReorder.vue?vue&type=template&id=6ec97292&scoped=true"
import script from "./MdtReorder.vue?vue&type=script&lang=js"
export * from "./MdtReorder.vue?vue&type=script&lang=js"
import style0 from "./MdtReorder.vue?vue&type=style&index=0&id=6ec97292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec97292",
  null
  
)

export default component.exports